// import React, { useState } from "react";
// // import "./formInput.css";

// function ExcludeInput(props) {
//   const [focused, setFocused] = useState(false);
//   const {
//     width,
//     padding,
//     height,
//     label,
//     errorMessage,
//     required,
//     // onChange,
//     onChange = () => {},
//     icon,
//     disabled = false, 
//     bg,
//     ...inputProps
//   } = props;

//   const handleFocus = () => {
//     setFocused(true);
//   };

//   const handleChange = (event) => {
//     const { value } = event.target;
//     // Validate the date input to ensure year is exactly 4 digits
//     if (inputProps.type === 'date') {
//       const datePattern = /^\d{4}-\d{2}-\d{2}$/;
//       const yearPattern = /^\d{4}$/;
//       const parts = value.split('-');

//       // Ensure year part has exactly 4 digits
//       if (parts.length === 3 && yearPattern.test(parts[0]) && datePattern.test(value)) {
//         onChange(event);
//       } else if (parts.length < 3) {
//         onChange(event); // Allow intermediate input for partial dates
//       }
//     } else {
//       onChange(event);
//     }
//   };

//   const currentYear = new Date().getFullYear();
//   const minYear = currentYear - 80;
//   const maxYear = currentYear - 14;

//   const maxYearHire = new Date(new Date().setMonth(new Date().getMonth() + 3)).toISOString().split("T")[0]


//   return (
//     <div className="formInput">
//       <label>
//         {label}
//         {required && <span>*</span>}
//       </label>
//       <input
//         {...inputProps}
//         onChange={handleChange}
//         onBlur={handleFocus}
//         onFocus={handleFocus}
//         focused={focused.toString()}
//         style={{ height, padding, width, backgroundColor: bg, opacity: disabled ? 0.6 : 1}}
//         min={(inputProps.name === "hire_date")?`${currentYear-70}-01-01`:`${minYear}-01-01`}
//         max={(inputProps.name === "hire_date")?maxYearHire:`${maxYear}-12-31`}
//       />
//     </div>
//   );
// }

// export default ExcludeInput;










import React, { useState } from "react";

function ExcludeInput(props) {
  const [focused, setFocused] = useState(false);
  const {
    width,
    padding,
    height,
    label,
    required,
    onChange = () => {},
    disabled = false,
    bg,
    suffix,
    value,
    ...inputProps
  } = props;

  const handleFocus = () => setFocused(true);

  const handleChange = (event) => {
    const { value } = event.target;
    // allow empty or digits
    if (/^\d*$/.test(value)) {
      onChange({ target: { value } });
    }
  };

  return (
    <div className="formInput" style={{ position: "relative", display: "inline-block", width }}>
      <label>
        {label}
        {required && <span>*</span>}
      </label>
      <input
        {...inputProps}
        type="text"
        value={value}
        onChange={handleChange}
        onBlur={handleFocus}
        onFocus={handleFocus}
        style={{
          height,
          padding,
          width: "100%",
          backgroundColor: bg,
          opacity: disabled ? 0.6 : 1,
          paddingRight: suffix ? "50px" : undefined
        }}
        disabled={disabled}
      />
      {suffix && (
        <span
          style={{
            position: "absolute",
            right: "10px",
            top: "65%",
            transform: "translateY(-50%)",
            color: "#555",
            pointerEvents: "none"
          }}
        >
          {suffix}
        </span>
      )}
    </div>
  );
}

export default ExcludeInput;
